import {Component, OnDestroy, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs/Rx';
import {AlertService, EventManager, JhiLanguageService, ParseLinks} from 'ng-jhipster';

import {Historique} from './historique.model';
import {HistoriqueService} from './historique.service';
import {ExportService, ITEMS_PER_PAGE, Principal} from '../../shared';
import {CandidatureFormation, CandidatureFormationService} from '../candidature';

@Component({
    selector: 'jhi-historique',
    templateUrl: './historique.component.html'
})
export class HistoriqueComponent implements OnInit, OnDestroy {

    currentAccount: any;
    historiques: Historique[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    private subscription: any;
    candidatureFormationId: number;
    private candidatureFormation: CandidatureFormation = null;
    isLoading: boolean = false;

    constructor(private jhiLanguageService: JhiLanguageService,
                private historiqueService: HistoriqueService,
                private parseLinks: ParseLinks,
                private alertService: AlertService,
                private principal: Principal,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private eventManager: EventManager,
                private route: ActivatedRoute,
                private candidatureFormationService: CandidatureFormationService,
                private exportService: ExportService) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['historique']);
        this.subscription = this.route.params.subscribe(params => {
            this.candidatureFormationId = params['candidatureFormationId'];
        });
    }

    loadAll() {
        this.isLoading = false;
        this.historiqueService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            candidatureId: this.candidatureFormation.candidatureId,
            candidatureFormationId: this.candidatureFormation.id,
            sort: this.sort()
        }).subscribe(
            (res: Response) => {
                this.onSuccess(res.json(), res.headers) ;
            },
            (res: Response) => this.onError(res.json())
        );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.candidatureFormationId != null) {
            this.router.navigate(['/historique/candidatureFormation/' + this.candidatureFormationId], {
                queryParams:
                    {
                        page: this.page,
                        size: this.itemsPerPage,
                        sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                    }
            });
        } else {
            this.router.navigate(['/historique'], {
                queryParams:
                    {
                        page: this.page,
                        size: this.itemsPerPage,
                        sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                    }
            });
        }
        this.loadAll();
    }

    clear() {
        this.page = 0;
        this.router.navigate(['/historique', {
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }]);
        this.loadAll();
    }

    ngOnInit() {
        if (this.candidatureFormationId != null) {
            this.candidatureFormationService.find(this.candidatureFormationId, false).subscribe(candidatureFormation => {
                if (candidatureFormation != null) {
                    this.candidatureFormation = candidatureFormation;
                    this.loadAll();
                }
            });
        }

        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInHistoriques();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    static trackId(index: number, item: Historique) {
        return item.id;
    }


    registerChangeInHistoriques() {
        this.eventSubscriber = this.eventManager.subscribe('historiqueListModification', (response) => this.loadAll());
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private onSuccess(data, headers) {
        this.isLoading = false;
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.historiques = data;
        this.historiqueService.fillUser(this.historiques) ;
    }

    private onError(error) {
        this.isLoading = false;
        this.alertService.error(error.message, null, null);
    }

    private formatData(historiqueCode: String, nomDuChamp: String, data: string): String {
        let dataFormatee: String = "";
        if (data != null) {
            let nomDuchampExport : String = "";
            if (historiqueCode=="STATUT" && ( nomDuChamp == "donneeAvant" || nomDuChamp == "donneeApres" ) ) {
                nomDuchampExport="STATUT" ;
            }
            if (historiqueCode=="STATUTEI" && ( nomDuChamp == "donneeAvant" || nomDuChamp == "donneeApres" ) ) {
                nomDuchampExport="EI" ;
            }
            let format: (dataValue: any) => String = this.exportService.rechercheFormatageDonnee(nomDuchampExport);
            dataFormatee = format(data);

        }
        return dataFormatee;
    }

    private goToCandidature() {
        this.candidatureFormationService.find(this.candidatureFormationId, false).subscribe(candidatureFormation => {
            if (candidatureFormation != null) {
                if (candidatureFormation.reinscription) {
                    this.router.navigate(['/reinscription/' + candidatureFormation.id]);
                } else {
                    this.router.navigate(['/candidature/' + candidatureFormation.id]);
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique.component.ts